export default __webpack_public_path__ + "static/media/icaew_grid_s.3cef9fb6.jpg";